import { useState } from "react";

export default function InfoCard({ destino }) {
    const [isHover, setIsHover] = useState(false);

    return (
        <div
            style={{
                width: "100%",
                padding: "10px",
                display: "flex",
                justifyContent: "center",
                marginBottom: "40px",
            }}
        >
            <a
                href={destino}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
                style={{
                    width: "800px",
                    backgroundColor: "#fff",
                    border: "1px solid #e5e5e5",
                    borderRadius: "16px",
                    padding: "20px 24px",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "16px",
                    textDecoration: "none",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                    transform: isHover ? "translateY(-2px)" : "translateY(0)",
                    boxShadow: isHover
                        ? "0 8px 24px rgba(0,0,0,0.08)"
                        : "0 1px 2px rgba(0,0,0,0.05)",
                    borderColor: isHover ? "#d4d4d4" : "#e5e5e5",
                }}
            >
                {/* Ícone */}
                <div
                    style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "8px",
                        // backgroundColor: isHover ? "#ead5ff" : "#f3e8ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        marginTop: "2px",
                        transition: "all 0.25s ease",
                    }}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.8}
                        stroke={isHover ? "black" : "#6b7280"}
                        style={{
                            width: "18px",
                            height: "18px",
                            transition: "all 0.25s ease",
                        }}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19.5 14.25v-8.25a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6v12a2.25 2.25 0 002.25 2.25h10.5A2.25 2.25 0 0019.5 18v-3.75zm-3-10.5v4.5h4.5"
                        />
                    </svg>
                </div>

                {/* Texto */}
                <div>
                    <h3
                        style={{
                            fontSize: "18px",
                            fontWeight: 600,
                            color: isHover ? "#1EFF86" : "#000",
                            margin: 0,
                            lineHeight: 1.3,
                            transition: "color 0.25s ease",
                        }}
                    >
                        Leia também: Benefícios de Declarar Corretamente os Impostos
                    </h3>

                    <p
                        style={{
                            fontSize: "15px",
                            color: "#6b7280",
                            marginTop: "8px",
                            marginBottom: 0,
                            lineHeight: 1.5,
                        }}
                    >
                        O outro lado da moeda: o que você ganha ao ficar em dia com o Leão.
                    </p>
                </div>
            </a>
        </div>
    );
}